<div class="w-full h-fit bg-[var(--p-primary-950)]">
  <div
    class="w-full max-w-[1280px] mx-auto h-fit px-[20px] md:px-[40px] py-[64px] md:py-[128px] flex flex-col gap-[32px] md:gap-[64px] justify-center items-center"
  >
    <div class="text-[20px] leading-7 md:text-[32px] md:leading-12 font-bold text-[var(--p-primary-400)]">
      {{ 'MEMBERS' }}
    </div>
    <div class="text-[32px] leading-12 md:text-[48px] md:leading-16 font-bold text-[var(--p-primary-50)]">
      {{ 'home.executives' | translate }}
    </div>
    <div class="w-full flex gap-[40px] md:gap-[24px] justify-center flex-col md:flex-row">
      @for (member of memberList(); track member.name) {
        <div #memberDiv class="flex flex-col gap-[16px] md:gap-[24px] w-full mx-auto p-[16px] md:p-[24px] rounded-[8px] member-gradient">
          <img [src]="member.url" alt="member" class="w-[72px] aspect-square" />

          <div class="flex flex-col">
            <div class="flex justify-between items-center flex-wrap gap-[8px]">
              <div class="flex flex-col gap-[8px] justify-start items-start">
                <div class="text-[20px] font-bold leading-7 text-[var(--p-primary-50)] md:text-[24px] md:leading-8">
                  {{ member.name }}
                </div>
                <div class="text-[14px] font-bold leading-5 text-[var(--p-primary-200)] md:text-[16px] md:leading-6">
                  {{ member.position }}
                </div>
              </div>
              <div (click)="goToLinkedIn(member.linkedIn)" class="flex ml-auto justify-end self-end">
                <img alt="linkedIn" class="w-[24px] h-[24px] m-[12px] cursor-pointer" src="/images/common/linkedin-logo.svg" />
              </div>
            </div>
            <div class="h-[1px] w-full bg-[var(--p-primary-600)] my-[16px]"></div>
            <div class="flex flex-col gap-[4px] font-medium text-[14px] leading-5 md:text-[16px] md:leading-6">
              <div class="text-[var(--p-primary-200)] font-medium">{{ member.previous }}</div>
              @for (experience of member.experience; track experience) {
                <div class="text-[var(--p-primary-400)] font-normal">{{ experience }}</div>
              }
            </div>
          </div>
        </div>
      }
    </div>
    <div class="h-[1px] w-full bg-[var(--p-primary-700)] my-[24px]"></div>
    <div class="flex flex-col md:flex-row justify-between w-full gap-[24px]">
      <div class="flex flex-col gap-[8px]">
        <div class="text-[var(--p-primary-200)] font-bold text-[24px] leading-8">
          {{ 'home.strategic-advisory' | translate }}
        </div>
        <div class="text-[var(--p-primary-400)] text-[16px] leading-6">
          {{ 'home.strategic-advisory-explain' | translate }}
        </div>
      </div>
      @for (advisor of advisorList(); track advisor.name) {
        <div
          [style.width.px]="memberWidth()"
          class="flex flex-col gap-[4px] md:gap-[8px] w-full p-[16px] md:p-[24px] rounded-[8px] member-gradient shrink-0"
        >
          <img [src]="advisor.url" alt="advisor" class="w-[72px] aspect-square" />
          <div class="flex flex-col">
            <div class="flex justify-between items-center flex-wrap gap-[8px] items-end">
              <div class="flex flex-col gap-[8px] justify-start items-start">
                <div class="text-[20px] font-bold leading-7 text-[var(--p-primary-50)] md:text-[24px] md:leading-8">
                  {{ advisor.name }}
                </div>
              </div>
              <div (click)="goToLinkedIn(advisor.linkedIn)" class="flex ml-auto justify-end self-end">
                <img alt="linkedIn" class="w-[24px] h-[24px] m-[12px] cursor-pointer" src="/images/common/linkedin-logo.svg" />
              </div>
            </div>
            <div class="h-[1px] w-full bg-[var(--p-primary-600)] my-[16px]"></div>
            <div class="flex flex-col gap-[4px] font-medium text-[14px] leading-5 md:text-[16px] md:leading-6">
              @for (experience of advisor.experience; track experience) {
                <div class="text-[var(--p-primary-400)] font-normal">{{ experience }}</div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
